import * as constants from 'appConstants';
import { createAction } from 'appUtils';

export const fetchPredictionHours = (params) =>
  createAction(constants.FETCH_PREDICTION_HOURS.TRIGGER, params);
